exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".margin-left-override {\n    margin-left: 24px !important;\n}\n\n.about-version {\n    font-size: 14px;\n    color: #565656;\n    font-weight: 500;\n}\n\n.about-build {\n    font-size: 14px;\n    color: #565656;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/about-dialog/about-dialog.component.css
// module id = 830
// module chunks = 0